<template>
  <div id="pastes">
    <v-dialog v-model="itemDelete.modal" max-width="600px">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title class="text-h5"
          >Are you sure you want to delete this item?
        </v-card-title>
        <v-card-subtitle
          >You are deleting {{ itemDelete.item.attachment }}, it will be gone
          forever.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="itemDelete.modal = false"
            >Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="red darken-1"
            text
            @click="deleteItemConfirm()"
            >Delete
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit.modal" max-width="600px">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5"
            >Editing Item ({{ edit.item.originalFilename }})</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  class="rounded-xl"
                  v-model="edit.item.name"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="edit.modal = false"
          >
            Close
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="editItemConfirm()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container v-if="!loading">
      <v-row>
        <v-col class="d-inline-flex">
          <v-text-field
            class="rounded-xl"
            v-model="show.search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            @click:append="getItems(true, true)"
            v-on:keyup.enter="getItems(true, true)"
          ></v-text-field>
          &nbsp;
          <div class="pt-3">
            <v-btn
              class="rounded-xl"
              color="secondary"
              dark
              @click="$router.push('/pastes/create')"
              >Create
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in items.gallery" :key="'item-' + item.id" md="4">
          <v-card
            :loading="loading"
            class="rounded-xl d-flex flex-column"
            elevation="8"
          >
            <v-toolbar>
              <v-toolbar-title>{{ item.name }}</v-toolbar-title>
            </v-toolbar>
            <v-img
              v-if="item.type === 'image'"
              :src="'/i/' + item.attachment"
              contain
              height="220"
            ></v-img>
            <video v-if="item.type === 'video'" controls height="298">
              <source :src="'/i/' + item.attachment" type="video/mp4" />
            </video>
            <h1
              v-if="item.type !== 'image' && item.type !== 'video'"
              class="text-center"
              style="line-height: 220px"
            >
              No Preview
            </h1>
            <v-card-text>
              <div v-if="item.type">
                Type:
                {{
                  String(item.type).charAt(0).toUpperCase() +
                  String(item.type).slice(1)
                }}
              </div>
              <div v-else>Type: Binary</div>
              <div>Original: {{ item.originalFilename }}</div>

              <div>Uploaded Name: {{ item.attachment }}</div>

              <div>
                Created at:
                {{ dayjs(item.createdAt).format("Do of MMMM YYYY, h:mm A") }}
              </div>
              <div>Filesize: {{ fileSize(item.fileSize) }}</div>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <v-card-text class="text-center">
              <v-chip
                class="mr-2"
                color="indigo"
                text-color="white"
                @click="editItem(item)"
              >
                <v-icon left> mdi-pencil</v-icon>
                Edit
              </v-chip>
              <v-chip
                class="mr-2"
                color="red"
                text-color="white"
                @click="deleteItem(item)"
              >
                <v-icon left> mdi-delete</v-icon>
                Delete
              </v-chip>
              <v-chip
                class="mr-2"
                color="teal"
                text-color="white"
                @click="copyLink(item)"
              >
                <v-icon left> mdi-content-copy</v-icon>
                Link
              </v-chip>
              <v-chip
                :href="'/i/' + item.attachment"
                class="mr-2"
                color="deep-purple"
                text-color="white"
              >
                <v-icon left> mdi-download</v-icon>
                Download
              </v-chip>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="justify-center align-center text-center">
        <v-pagination
          v-model="page"
          :length="items.pager.endPage"
          :total-visible="7"
        ></v-pagination>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"

export default {
  name: "Gallery",
  data() {
    return {
      items: {
        items: [],
        pager: []
      },
      show: {
        search: ""
      },
      loading: false,
      page: 1,
      itemDelete: {
        modal: false,
        item: []
      },
      edit: {
        modal: false,
        item: []
      }
    }
  },
  methods: {
    search() {},
    dayjs(params) {
      return dayjs(params)
    },
    fileSize(fileSize) {
      var i = -1
      var byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    editItemConfirm() {
      this.axios
        .put("/api/v1/gallery/edit", {
          id: this.edit.item.id,
          name: this.edit.item.name
        })
        .then(() => {
          this.edit.modal = false
          this.edit.item = []
          this.getItems(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    editItem(item) {
      this.edit.item = item
      this.edit.modal = true
    },
    copyLink(item) {
      navigator.clipboard.writeText(
        "https://" +
          this.$store.state.user.domain.domain +
          "/" +
          item.attachment
      )
    },
    deleteItem(item) {
      this.itemDelete.item = item
      this.itemDelete.modal = true
    },
    deleteItemConfirm() {
      this.axios
        .post("/api/v1/gallery/delete", {
          id: this.itemDelete.item.id
        })
        .then(() => {
          this.itemDelete.modal = false
          this.itemDelete.item = []
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.$store.commit(
              "setDiscordCache",
              JSON.parse(res.data.discordUserCache)
            )
          })
          this.getItems(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getItems(init, resetPage) {
      if (resetPage) {
        this.page = 1
      }
      this.loading = true
      this.axios
        .get(
          "/api/v1/gallery/personal/pastes/" +
            this.page +
            "?search=" +
            this.show.search
        )
        .then((res) => {
          if (init) {
            this.items = res.data
            this.loading = false
          } else {
            this.item.push(res.data)
            this.loading = false
          }
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getItems(true, true)
  },
  watch: {
    page() {
      this.getItems(true, false)
    }
  }
}
</script>

<style scoped></style>
